// src/components/cart/PaymentStep.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ShoppingCart, CheckCircle, Loader, XCircle } from 'lucide-react';

const PaymentStep = ({
  paymentMethod,
  setPaymentMethod,
  subtotal,
  shippingCost,
  totalPrice,
  currency,
  processCheckout,
  loading,
  orderStatus,
  setStep,
}) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const finalPrice = totalPrice;

  return (
    <motion.div variants={containerVariants} initial="hidden" animate="visible">
      {/* Payment Method */}
      <div className="mb-8">
        <p className="text-[#DBAE6E] font-semibold mb-4">Select your payment method</p>
        <label className="flex items-center gap-3 mb-4 cursor-pointer">
          <input
            type="radio"
            value="cod"
            checked={paymentMethod === 'cod'}
            onChange={() => setPaymentMethod('cod')}
            className="appearance-none w-6 h-6 border-2 border-[#DBAE6E] rounded-full checked:bg-[#DBAE6E]"
          />
          <span className="text-lg text-black dark:text-white">Cash on Delivery</span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="radio"
            value="prepaid"
            checked={paymentMethod === 'prepaid'}
            onChange={() => setPaymentMethod('prepaid')}
            className="appearance-none w-6 h-6 border-2 border-[#DBAE6E] rounded-full checked:bg-[#DBAE6E]"
          />
          <span className="text-lg text-black dark:text-white">Pay Now</span>
        </label>
      </div>

      {/* Price Summary */}
      <div className="text-gray-400 mb-8 bg-white-900 dark:bg-gray-900 p-4 rounded-lg space-y-2">
        <p>Subtotal: {currency} {subtotal.toFixed(2)}</p>
        <p>Shipping: {currency} {shippingCost.toFixed(2)}</p>

        <p className="text-black dark:text-white font-bold text-lg pt-2 border-t border-white/10">
          Final Price: {currency} {finalPrice.toFixed(2)}
        </p>
      </div>

      {/* Buttons */}
      <div className="flex justify-between">
        <motion.button
          onClick={() => setStep(2)}
          className="px-6 py-3 border border-[#DBAE6E] text-[#DBAE6E] rounded-lg text-lg font-medium"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <ArrowLeft size={22} className="inline mr-2" /> Back
        </motion.button>

        <motion.button
          onClick={processCheckout}
          className={`px-10 py-5 rounded-lg text-xl font-semibold flex items-center gap-3 ${orderStatus === 'success'
              ? 'bg-green-600 hover:bg-green-700'
              : orderStatus === 'failed'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-[#DBAE6E] text-black hover:bg-[#c9a055]'
            }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={loading}
        >
          {loading ? (
            <Loader size={28} className="animate-spin" />
          ) : orderStatus === 'success' ? (
            <>
              <CheckCircle size={28} /> Order Placed
            </>
          ) : orderStatus === 'failed' ? (
            <>
              <XCircle size={28} /> Failed
            </>
          ) : (
            <>
              <ShoppingCart size={28} /> Place Order
            </>
          )}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default PaymentStep;
